package org.braunequip.web.components.models

import kotlinx.serialization.Serializable

@Serializable
data class PinDTO(
    var id: Int? = null,
    var pin: String = "",
    var createdAt: String? = null,
    var description: String = ""
)